import {
  isGeneratedFilesArchiveDownload,
  resolveGeneratedFilesDownloadLabelKey,
} from "@frontend-shared/utils";
import { Download, FileArchive, Loader2 } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";

import type { IChatGeneratedFilesDialogFooterProps } from "./types";

// NOTE: NSAI-5312 — the button names what the click produces: "Download" for
// one file, "Download as ZIP" for several (resolveGeneratedFilesDownloadLabelKey).
const ChatGeneratedFilesDialogFooterComponent = ({
  selectedCount,
  isDownloading,
  progressLabel,
  onDownload,
  onCancel,
}: IChatGeneratedFilesDialogFooterProps): JSX.Element => {
  const { t } = useTranslation("common");
  const isArchive = isGeneratedFilesArchiveDownload({ selectedCount });

  return (
    <DialogFooter className="gap-2">
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
        data-testid="chat-generated-files-cancel"
      >
        {t("form_buttons.cancel")}
      </Button>
      <Button
        type="button"
        className="gap-2"
        onClick={onDownload}
        disabled={selectedCount === 0 || isDownloading}
        data-testid="chat-generated-files-download"
      >
        {isDownloading && <Loader2 className="size-4 animate-spin" />}
        {!isDownloading && isArchive && <FileArchive className="size-4" />}
        {!isDownloading && !isArchive && <Download className="size-4" />}
        <span>
          {isDownloading
            ? progressLabel
            : t(resolveGeneratedFilesDownloadLabelKey({ selectedCount }))}
        </span>
      </Button>
    </DialogFooter>
  );
};

export const ChatGeneratedFilesDialogFooter = memo(
  ChatGeneratedFilesDialogFooterComponent,
);
